import React, { Fragment } from 'react';
import Lside from '../../atom/TabNav/leftTab';
import './index.css';

const Lefttab = (props) => {
    return (
        <Fragment>
            <Lside tabArray={props.tabArray} activeTab={props.activeTab} activeClick={props.activeClick} />
            <div className={`col-md-8 col-lg-9 bgacc no_bg_before clearfix ${props.leftClassName}`}>
                {props.children}
            </div>
        </Fragment>

    )
}

export default Lefttab